//Banner
import BannerImage from "../assets/images/OneFifty_Availabilities/Banner.png"
import MobileImage from "../assets/images/OneFifty_Availabilities/Mobile-image.jpg"

//Components
import ListingCards from "../components/ListingCards";
import Footer from "../components/Footer";
import Banner from "../components/Hero";
import QuickNav from "../components/QuickNav";

//React Imports
import { Helmet } from "react-helmet";

let QuickLinks = {
    backgroundColor: "off-white",
    prev: {
        title: "Amenities",
        url: "/amenities"
    },
    next: {
        title: "Neighborhood",
        url: "/neighborhood"
    }
}
let footerData = {
    backgroundColor: "off-white"
}
let BannerData = {
    backgroundImage: BannerImage,
    mobileImage: MobileImage,
    heading: "Your Luxury Bushwick Apartment is Waiting",
    description: "Browse live availability at One Fifty below. Filter by residence type and price, then explore floor plans, inquire, or apply to find the home that suits your lifestyle.",
    color: "off-white-brown",
}

export default function Availabilities() {
    return (
        <>
            <Helmet>
                <title>Availability| Luxury Bushwick Apartments For Rent - EXR</title>
                <meta name="description" content="Explore available units to find the luxury Bushwick apartment for rent at One Fifty that perfectly suits your lifestyle." />
            </Helmet>
            <Banner data={BannerData} />
            <ListingCards />
            <QuickNav links={QuickLinks} />
            <Footer data={footerData} />
        </>
    )
}
